import { HeroNew } from "@/components/sections/hero-new";
import { Features } from "@/components/sections/features";
import { OurFeatures } from "@/components/sections/our-features";
import { TechShowcase } from "@/components/sections/tech-showcase";
import { InteriorShowcase } from "@/components/sections/interior-showcase";
import { DimensionsShowcase } from "@/components/sections/dimensions-showcase";
import { ModelsShowcase } from "@/components/sections/models-showcase";
import { Testimonials } from "@/components/sections/testimonials";
import { WhatsAppContact } from "@/components/sections/whatsapp-contact";
import { Helmet } from "react-helmet-async";

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>長安跨越V7-EV | 長安跨越香港獨家代理 | 電動七人車</title>
        <meta name="description" content="續航280公里，1號牌照可去機場，適合 Uber 滴滴網約車。零排放環保，經濟實惠 HK$0.5/公里。香港觀塘展示廳歡迎預約試駕。" />
      </Helmet>
      <main>
        <HeroNew />
        <Features />
        <Testimonials />
        <OurFeatures />
        {/* <VehicleGallery /> */}
        <InteriorShowcase />
        <DimensionsShowcase />
        <TechShowcase />
        <ModelsShowcase />
        <WhatsAppContact />
      </main>
    </>
  );
}
